<template>
  <span
    class="mr-3 mb-1 btn btn-blue w-10 h-10 flex items-center justify-center relative"
    :class="{ 'btn-red border border-red-300': filtering.hasChanges }"
    @click="filtering.active = !filtering.active"
    title="Open filters"
  >
    <span
      class="absolute right-0 top-0 text-xs text-white px-1 rounded-full leading-none"
      v-if="filtering.hasChanges"
    >
      <i class="fas fa-exclamation fa-xs"></i>
    </span>
    <i class="fas fa-sliders-h"></i>
  </span>
</template>

<script>
export default {
  props: {
    filtering: {}
  }
}
</script>
